import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AccordionFadeComponent } from './accordion-fade.component'
import { MatCardModule } from '@angular/material/card'

@NgModule({
  declarations: [
    AccordionFadeComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
  ],
  exports: [
    AccordionFadeComponent
  ]
})
export class AccordionFadeModule {}
